import { Link } from 'react-router-dom'
import { PATH_HELPERS } from 'src/constants/navigation'
import { SearchListing } from 'src/types/listings'
import ListingCard from '../../ListingCard'
import styles from './ListView.module.scss'

export interface ListViewProps {
  listings: SearchListing[]
  customerId: string
}

export const ListView = ({ listings, customerId }: ListViewProps) => {
  return (
    <div className={styles.listView}>
      {listings?.map(listing => (
        <Link
          to={PATH_HELPERS.listing.buildPath(customerId, listing.id)}
          className={styles.savedListingLink}
          aria-label={listing.vector}
          data-qa={`listing-link-${listing.id}`}
          key={listing.id}
        >
          <ListingCard listing={listing} className={styles.savedListingCard} />
        </Link>
      ))}
    </div>
  )
}
